/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import "../../virtualShop.css";

class VirtualShopHeader extends Component {
    render() {
        return (<div className="cotvs_header">
            <div className="cotvs_logo"></div>
        </div>)
    }
}
export default VirtualShopHeader;